const domaine = {
  name: 'Domaine Sans Text',
  bold_ttf:
    'https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.353/images/store/47/fonts/Domaine_Sans_Bold.ttf',
  bold_woff2:
    'https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.353/images/store/47/fonts/Domaine_Sans_Bold.woff2',
  light_ttf:
    'https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.353/images/store/47/fonts/Domaine_Sans_Light.ttf',
  medium_ttf:
    'https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.353/images/store/47/fonts/Domaine_Sans_Medium.ttf',
  regular_ttf:
    'https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.353/images/store/47/fonts/Domaine_Sans_Regular.ttf',
  regular_woff2:
    'https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.353/images/store/47/fonts/Domaine_Sans_Regular.woff2',
}

export const fontSecondary = {
  '@font-face': [
    {
      fontFamily: domaine.name,
      fontWeight: 'normal',
      src: 'url("https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.353/images/store/47/fonts/Domaine_Sans_Regular.woff2")',
    },
    {
      fontFamily: domaine.name,
      fontWeight: 500,
      src: 'url("https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.353/images/store/47/fonts/Domaine_Sans_Medium.ttf")',
    },
    {
      fontFamily: domaine.name,
      fontWeight: 700,
      src: 'url("https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.353/images/store/47/fonts/Domaine_Sans_Bold.woff2")',
    },
    {
      fontFamily: domaine.name,
      fontWeight: 300,
      src: 'url("https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.353/images/store/47/fonts/Domaine_Sans_Light.ttf")',
    },
  ],
}
